import { render, staticRenderFns } from "./CardMiniProductionZone.vue?vue&type=template&id=5a46633e&scoped=true&"
import script from "./CardMiniProductionZone.vue?vue&type=script&lang=js&"
export * from "./CardMiniProductionZone.vue?vue&type=script&lang=js&"
import style0 from "./CardMiniProductionZone.vue?vue&type=style&index=0&id=5a46633e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a46633e",
  null
  
)

export default component.exports